<h2 mat-dialog-title class="text-lg font-bold mb-1"> {{ isEditMode ? 'Editar Registro' : 'Nuevo Registro' }}</h2>
<mat-dialog-content class="modal-content">
  <form #createForm="ngForm" class="grid grid-cols-2 gap-4">
    <!-- ng-select for distribution-chain -->
    <div [ngClass]="{'disabled': isEditMode}" class="col-span-2">
      <label>Cadena de Distribución</label>
      <ng-select [(ngModel)]="currentCreateMaterialChain.distributionChainId" [items]="distributionChainList"
        bindLabel="name" bindValue="_id" [searchable]="true" placeholder="Seleccione una cadena de distribución"
        name="distributionChainId" [appendTo]="'body'" required [disabled]="isEditMode">
      </ng-select>
    </div>

    <app-form-section *ngIf="fieldsMasterDataStatus" title="Campos de usuario" icon="business" iconColor="blue"
      class="col-span-2">
      <app-user-fields-configuration [fields]="fieldsMasterData" [model]="currentCreateMaterialChain">
      </app-user-fields-configuration>
    </app-form-section>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
  <button mat-raised-button color="primary" (click)="save()" class="justify-end">
    {{ isEditMode ? 'Actualizar' : 'Guardar' }}
  </button>
</mat-dialog-actions>